import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressStateCodeModel } from 'src/app/models/addressstatecode.models';
import { environment } from 'src/environments/environment';
import { CountyCodeModel } from './../../../models/county-codes';

@Injectable({
  providedIn: 'root'
})

export class AddressService {

  constructor(private http: HttpClient) { }

  baseUrlCodeTable = environment.baseUrlCodeTable;

  stateCodes$: Observable<AddressStateCodeModel> = this.http.get<AddressStateCodeModel>(`${this.baseUrlCodeTable + '/States'}`);
  countyCodes$: Observable<CountyCodeModel> = this.http.get<CountyCodeModel>(`${this.baseUrlCodeTable + '/Counties'}`);
  addressTypes$: Observable<AddressStateCodeModel> = this.http.get<AddressStateCodeModel>(`${this.baseUrlCodeTable + '/addresstypes'}`);
}
